import { render, staticRenderFns } from "./MomentTransferredListComponent.vue?vue&type=template&id=00364c52&scoped=true&"
import script from "./MomentTransferredListComponent.vue?vue&type=script&lang=ts&"
export * from "./MomentTransferredListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./MomentTransferredListComponent.vue?vue&type=style&index=0&id=00364c52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00364c52",
  null
  
)

export default component.exports